import React from "react";
import { onAuthStateChanged, getAuth, signOut } from "firebase/auth";
import { auth } from "../config/firebase";
import { useNavigate } from "react-router-dom";
import { getUserById } from "lib/request/getUserById";
const useAuthentication = () => {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      getUserById(user.uid).then((user) => {
        setUser(user);

        setLoading(false);
      });
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const logout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        navigate("/");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  return { user, loading, logout };
};

export default useAuthentication;
